const DANGEROUS_KEYS = new Set(["__proto__", "constructor", "prototype"]);

const stripDangerous = (key: string, value: unknown) => {
	if (DANGEROUS_KEYS.has(key)) {
		return undefined;
	}
	return value;
};

export const safeJsonParse = <T = unknown>(input: string): T | null => {
	try {
		return JSON.parse(input, stripDangerous) as T;
	} catch {
		return null;
	}
};
